'use client';

import { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';

export function LandingHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { label: 'Chattel Mortgage', href: '/chattel-mortgage' },
    { label: 'Truck Finance', href: '/truck-finance' },
    { label: 'Car Finance', href: '/car-finance' },
    { label: 'Resources', href: '/resources' },
    { label: 'Apply', href: 'tel:0384569966' },
  ];

  return (
    <header className="bg-valco-blue text-white sticky top-0 z-50" style={{ boxShadow: '0 4px 6px -1px rgba(255, 255, 255, 0.025), 0 2px 4px -1px rgba(255, 255, 255, 0.015)' }}>
      <div className="container-padding">
        <div className="flex items-center justify-between pt-4 pb-3">
          {/* Logo */}
          <Link href="/" className="flex items-center">
            <Image 
              src="/valco-logo.png"
              alt="VALCO GROUP"
              width={240}
              height={60}
              className="h-[50px] md:h-[60px] w-auto"
              priority
            />
          </Link>

          {/* Hamburger Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-white hover:text-accent-orange transition-colors focus:outline-none"
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="bg-valco-blue border-t border-slate-600">
          <div className="container-padding py-4">
            <nav className="space-y-4">
              {menuItems.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className="block text-white hover:text-accent-orange transition-colors py-2 font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}